import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ProSidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import { Row } from "react-bootstrap";
import { FaHome, FaExchangeAlt, FaAlignJustify, FaShippingFast, FaSprayCan, FaShapes, FaTicketAlt, FaChartBar, FaEllipsisH } from 'react-icons/fa';
import 'react-pro-sidebar/dist/css/styles.css';

const Sidebar = (props) => {
  const [toggled, setToggled] = useState(false);
  const [collapsed, setCollapsed] = useState(true);

  const handleCollapsedChange = () => {
    setCollapsed(!collapsed);
  };

  const handleToggleSidebar = (value) => {
    setToggled(value);
  };

  return (
    <div className={`leftSidebar ${collapsed ? "w-0" : ""}`}>
      <div className="toggleSidebar">
        <FaAlignJustify onClick={handleCollapsedChange}/>
      </div>
      <ProSidebar
        image={false}
        rtl={false}
        collapsed={collapsed}
        toggled={toggled}
        onToggle={handleToggleSidebar}
      >
        <Menu iconShape="square">
          <MenuItem icon={<FaHome />}>
            Home
            <Link to={{ pathname: "https://eggplant.fi"}} target="_blank" />
          </MenuItem>
          <SubMenu title="Trade" icon={<FaExchangeAlt />}>
            <MenuItem>
              Exchange
              <Link to={{ pathname: "https://swap.eggplant.fi/#/swap"}} target="_blank" />
            </MenuItem>
            <MenuItem>
              Liquidity
              <Link to={{ pathname: "https://swap.eggplant.fi/#/pool"}} target="_blank" />
            </MenuItem>
          </SubMenu>
          <MenuItem icon={<FaShippingFast />}>
            Farms
            <Link to={{ pathname: "https://eggplant.fi/farms"}} target="_blank" />
          </MenuItem>
          <MenuItem icon={<FaSprayCan />}>
            Pools
            <Link to={{ pathname: "https://eggplant.fi/pools"}} target="_blank" />
          </MenuItem>
          <MenuItem icon={<FaShapes />}>
            Nfts
            <Link to={{ pathname: "https://eggplant.fi/pools"}} target="_blank" />
          </MenuItem>
          <SubMenu title="Games" icon={<FaTicketAlt />}>
            <MenuItem className={props.activeRoute === "slot" ? "active" : ""}>
              Slot Machine
              <Link to="/slot_machine"/>
            </MenuItem>
            <MenuItem className={props.activeRoute === "coin" ? "active" : ""}>
              Coin Flip
              <Link to="/coin_flip"/>
            </MenuItem>
          </SubMenu>
          <SubMenu title="Info" icon={<FaChartBar />}>
            <MenuItem>
              Dex.guru chart
              <Link to={{ pathname: "https://dex.guru/token/0x21adb1c644663069e83059ac3f9d9ca1133d29e4-bsc"}} target="_blank" />
            </MenuItem>
            <MenuItem>
              Coingecko
              <Link to={{ pathname: "https://www.coingecko.com/en/coins/eggplant-finance"}} target="_blank" />
            </MenuItem>
          </SubMenu>
          <SubMenu title="More" icon={<FaEllipsisH />}>
            <MenuItem>
              Github
              <Link to={{ pathname: "https://github.com/eggplant-finance/"}} target="_blank" />
            </MenuItem>
            <MenuItem>
              Medium
              <Link to={{ pathname: "https://eggplantfinance.medium.com/"}} target="_blank" />
            </MenuItem>
          </SubMenu>
        </Menu>
      </ProSidebar>
    </div>
  )
}

export default Sidebar;
